<template>
  <ListWrapper
    :url="url"
    :hasTitle="false"
    :hasAddButton="false"
    :isUseInSidebar="true"
    menuBarClass="padding-x-16"
    searchTxtClass="width-percent-100"
    filterHistoryType="MOBILE"
    @getPermissions="getPermissions"
    @getLoading="getLoading"
  >
    <template #top-area>
      <collapse-transition>
        <div v-if="selectedItems.length" class="checkbox-filter__counter">
          <span
            class="checkbox-filter__indeterminate"
            @click="handleDeleteSelectedItems()"
          ></span>
          <span class="checkbox-filter__count">
            {{ `${selectedItems.length} ${$lang.selected_case}` }}
          </span>
        </div>
      </collapse-transition>
    </template>
    <template slot-scope="{ items }">
      <LoadingWrapper :loading="listLoading">
        <template #loading>
          <Loading :count="10" />
        </template>
        <template #default>
          <b-row class="margin-0 padding-x-16">
            <b-col
              v-for="(item, index) in generateItems(items)"
              :key="index"
              cols="12"
              class="border--solid border--complementary-50 border-radius-8 padding-x-12 padding-y-8 margin-bottom-8"
            >
              <label class="flex-start-start margin-0">
                <b-form-checkbox
                  v-model="item.selected"
                  size="lg"
                  :value="true"
                  :unchecked-value="false"
                  @change="handleSelectItem(item)"
                />
                <span class="checkbox__item-label">
                  <LazyImageBox
                    :isImage="false"
                    :fullName="item.fullName"
                    :parvandehNumber="item.parvandehNumber"
                    :firstCaption="item.termCaption"
                    leftBoxClass="padding-left-12 max-width-266"
                  />
                </span>
              </label>
            </b-col>
          </b-row>
        </template>
      </LoadingWrapper>
    </template>
  </ListWrapper>
</template>

<script>
import {
  ListWrapper,
  LazyImageBox,
  LoadingWrapper,
} from "@/components/re-design/";
import Loading from "./Loading.vue";
import { pathOr } from "ramda";
import {
  generateApiUrl,
  generateLang,
  setUniqueArrayOfObjects,
} from "@/shared/utils";
import { computed, ref, toRefs, watch } from "vue";

export default {
  components: {
    ListWrapper,
    LazyImageBox,
    LoadingWrapper,
    Loading,
  },
  setup(props, { emit }) {
    const handleClose = () => emit("close");

    const url = computed(() =>
      generateApiUrl(["report", "company_parvandeh_report"])
    );
    const permissions = ref([]);
    const getPermissions = (value) => (permissions.value = [...value]);
    const generateItems = (items) => {
      return items.map((item) => {
        const code = pathOr(null, ["parvandeh", "code"], item);
        const fullName = pathOr("", ["parvandeh", "person", "full_name"], item);
        const image = pathOr("", ["parvandeh", "person", "img"], item);
        const parvandehNumber = pathOr(
          "",
          ["parvandeh", "parvandeh_number"],
          item
        );
        const termCaption = pathOr("", ["term", "caption"], item);

        return {
          code,
          fullName,
          image,
          parvandehNumber,
          termCaption: `${generateLang(["term"])} ${termCaption}`,
          selected: false,
        };
      });
    };

    const listLoading = ref(false);
    const getLoading = (value) => (listLoading.value = value);

    // generate selected items
    const selectedItems = ref([]);
    const localStorageName = ref("dashboard-parvandeh-codes");
    const generateLocalStorageItems = () => {
      const storageData = localStorage.getItem(localStorageName.value);
      const storageItems = JSON.parse(storageData) || [];
      const mergedItems = [...storageItems, ...selectedItems.value];
      const uniqueItems = setUniqueArrayOfObjects(mergedItems, "code");
      localStorage.setItem(localStorageName.value, JSON.stringify(uniqueItems));
    };
    const handleSelectItem = (item) => {
      const itemIndex = selectedItems.value.findIndex(
        ({ code }) => code === item.code
      );

      if (itemIndex !== -1) {
        selectedItems.value.splice(itemIndex, 1);
      } else {
        selectedItems.value.push(item);
      }
      generateLocalStorageItems();
    };
    const handleDeleteSelectedItems = () => {
      selectedItems.value = [];
      handleClose();
    };

    // return data to be used in template
    return {
      url,
      handleClose,
      generateItems,
      getPermissions,
      selectedItems,
      handleSelectItem,
      handleDeleteSelectedItems,
      listLoading,
      getLoading,
    };
  },
};
</script>
